import type { components } from '@trackercop/contracts';

type Crawl = components['schemas']['Crawl'];

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString();
  } catch {
    return iso;
  }
}

export function crawlDurationMs(crawl: Pick<Crawl, 'startedAt' | 'completedAt'>): number | null {
  if (!crawl.startedAt) return null;
  const end = crawl.completedAt ? new Date(crawl.completedAt).getTime() : Date.now();
  return end - new Date(crawl.startedAt).getTime();
}

export function formatDuration(ms: number | null): string {
  if (ms === null) return '—';
  if (ms < 1000) return `${ms}ms`;
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const rs = s % 60;
  return `${m}m ${rs}s`;
}

const USD_FORMATTER_2DP = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const USD_FORMATTER_0DP = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatUsd(amount: number, fractionDigits: 0 | 2 = 2): string {
  return (fractionDigits === 0 ? USD_FORMATTER_0DP : USD_FORMATTER_2DP).format(amount);
}
